import React from 'react';
import noImage from '../../asset/Product/no_image.png';
import './style.css';

const ProductItem = (props) => {
  const { product } = props;

  return (
    <div className="product-item mb-4">
      <div className="product-item-img">
        <img
          src={product.main_image ? product.main_image : noImage}
          alt="product"
        />
      </div>
      <div className="product-item-info pl-4">
        {product.name}
        <br />
        <p style={{ color: '#4e4e4e' }}>
          {
            product.price
              ? `¥ ${product.price.toLocaleString()}  x  ${product.count}個`
              : ''
          }
        </p>
      </div>
    </div>
  );
};
export default ProductItem;
